import DateFnsUtils from "@date-io/date-fns";
import {
	Button,
	Grid,
	MenuItem,
	Typography,
	makeStyles,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import { useForm } from "react-hook-form";
import { ReactHookFormSelect } from "../../utils";

const useStyles = makeStyles((theme) => ({
	optionDiv: {
		gap: theme.spacing(1),
		backgroundColor: "white",
		padding: theme.spacing(1),
		marginBottom: theme.spacing(3),
		boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
		borderRadius: "5px 5px 5px 5px",
		[theme.breakpoints.down("xs")]: {
			gap: 0,
			paddingTop: theme.spacing(4),
		},
	},
	button: {
		height: "3.3rem",
		width: "6rem",
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			marginBottom: theme.spacing(4),
		},
	},
}));

export const OptionHandle = ({
	handleSearch,
	state,
	setState,
	singleOption,
}) => {
	const { handleSubmit, errors, control } = useForm();
	const classes = useStyles();

	return (
		<div style={{ paddingTop: "1rem" }}>
			<Grid container alignItems="center" className={classes.optionDiv}>
				<Grid item xs={12} sm={2} md={2}>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<DatePicker
							// autoOk
							style={{ width: "100%" }}
							orientation="landscape"
							inputVariant="outlined"
							openTo="date"
							value={state.tanggal}
							label="Date Time"
							onChange={(e) =>
								setState({ ...state, tanggal: moment(e).format("YYYY-MM-DD") })
							}
							disableFuture
						/>
					</MuiPickersUtilsProvider>
				</Grid>
				<Grid item xs={12} sm={2} md={2}>
					<ReactHookFormSelect
						id="iduser"
						name="iduser"
						label="ID User"
						control={control}
						error={errors.iduser}
						value={state.iduser}
						// handleOption={handleOption}

						rules={{
							required: {
								value: true,
								message: `ID User tidak boleh kosong`,
							},
						}}
						setState={setState}
						state={state}
						variant="outlined"
						margin="normal"
						fullWidth
					>
						<MenuItem value="none" disabled selected>
							--Pilih Users--
						</MenuItem>
						<MenuItem value="0" selected>
							All
						</MenuItem>
						{singleOption &&
							singleOption.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
					{errors.iduser && (
						<Typography variant="caption" color="error">
							{errors.iduser.message}
						</Typography>
					)}
				</Grid>
				<Grid item xs={12} sm={2} md={2}>
					<Button
						className={classes.button}
						variant="contained"
						color="primary"
						onClick={handleSubmit(handleSearch)}
					>
						Filter
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

export default OptionHandle;
